import { Address } from "@medplum/fhirtypes";

export function getPracticeAddress(address: Address | undefined): string {
  if (!address || (!address.city && !address.state)) {
    return "No address";
  }

  if (!address.city) {
    return address.state!;
  }

  if (!address.state) {
    return address.city!;
  }

  return `${address.city}, ${address.state}`;
}
